export const offerfitAppGroupIdGetPrimaryKpi = "/offerfit/:app_group_id/get_primary_kpi/:use_case_id";
